import "./HeaderBar.css";
import React, { useEffect, useState } from "react";
import configData from "../AppConfig.json";
import { APP_BRAND, APP_API, APP_JOB } from "../AppConfig";
import { BaseURL } from "../../components/Common";

/**
 * Generates the header bar for the app.
 * @returns Header bar.
 */
export function HeaderBar() {
    const [logoUrl, setLogoUrl] = useState(null);
    const [logoIsCustom, setLogoIsCustom] = useState(true);

    const fallbackLogo =
        window.brand === "Fielders"
            ? BaseURL("images/centenary_logo.png")
            : BaseURL("images/logo-lysaghtliving-white.png");

    useEffect(() => {
        const fetchLogo = async () => {
            try {
                const response = await fetch(`${APP_API}getlogo/?job=${APP_JOB}&brand=${APP_BRAND}`);
                if (!response.ok) {
                    throw new Error();
                }

                const blob = await response.blob();
                const objectUrl = URL.createObjectURL(blob);
                setLogoUrl(objectUrl);
                setLogoIsCustom(true);
            } catch (error) {
                setLogoUrl(fallbackLogo);
                setLogoIsCustom(false);
            }
        };

        fetchLogo();
    }, [fallbackLogo]);

    return (
        <div className={logoIsCustom ? "header headerCustom" : `header header${APP_BRAND}`}>
            <div>
                {logoUrl && (
                    <img
                        src={logoUrl}
                        alt={configData.Brand[APP_BRAND].name}
                    />
                )}
            </div>
        </div>
    );
}


